// extracted by mini-css-extract-plugin
export var newsletterConfirmContainer = "newsletter-module--newsletter-confirm-container--b0b1b";